import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import {  faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApplicableTableSettings, codesAesExportInfoList } from '../../../../tableSettings';
import useFastStorage from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../../ApplicationContext';
import { Portal } from 'react-portal';
import useSystemSettings from '../../../../hooks/useSystemSettings';
import { Search } from '../../../../filtering';
import { CodeExportInfoListItem } from '../../../../fms.data/models/CodeExportInfoListItem';
import { JobNames } from '../../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import ClearableSearch from '../../../../uiControls/ClearableSearch';
import TextBox from '../../../../ui/TextBox';
import EditableTable, { CellData, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { duplicateCell, findSecurityTask } from '../../../../util';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import useTableStorage from '../../../../hooks/useTableStorage';
import { ListOrderBy } from '../../../common/AbstractListView';
import { RefreshIconButton2 } from '../../../../ui/IconButton';


// export interface IExportInfo {
//   code?: string,
//   description?: string,
//   isNew?: boolean,
// }

// let inlineElement:IExportInfo = {};

// function ActionRenderer({ data, row }:any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

function CodeRenderer({data, row, cell}:any) {
  useEffect(() => {
    const focusElement = document.getElementById('ifms-aescode') as HTMLInputElement;
    if (focusElement) {
      focusElement.focus();
      focusElement.select();
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-aescode-${row.index}`} maxLength={2} value={data[row.index].code} onChange={(e) => {
          changeLineItem(row.index, {code: e.target.value, isUpdate: true })
          
          }} />
      </div>
    );
}

function DescriptionRenderer({data, row, cell}:any) {
    const changeLineItem = data[0].changeLineItem;
    return (
      <div style={{marginTop: '0px'}}>
        <TextBox textId={`ifms-aesdescription-${row.index}`} maxLength={1000} value={data[row.index].description}  onChange={(e) => {
          changeLineItem(row.index, {description: e.target.value, isUpdate: true })
          }} />
      </div>
    );
  
}

class EditableCodeExportInfoListItem extends CodeExportInfoListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
}

function formatElement(data:any) {
  const result = new EditableCodeExportInfoListItem();
  result.description = data.description;
  result.cid = data.cid;
  result.code = data.code;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data:Array<any>) {
  return data.map(d => formatElement(d));
}

function ExportInfos() {
  useFunction({invokers: {
    ifmsReferenceFilesSave: save,
    ifmsReferenceFilesCancel: cancelOperation,
  }});
  useFunctionKeys({onSave: handleSaveAndClose});

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const savedDataRef = useRef<Array<CodeExportInfoListItem>>([]);

  const tableStorage = useTableStorage();
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, ] = useFastStorage(`ifms-referenceFiles-aes-exportinfo-list`, []);
  //const [ei, setEi, , ediRef] = useFastStorage(`ifms-referenceFiles-aes-exportinfo-editindex`, -1);
  const systemSettings = useSystemSettings();
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeExportInfo);
  const [focusFirstCell, setFocusFirstCell] = useState({ dataLength: 0, focus: false });
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-aes-exportinfo-orderby`,{
    general1: 'code',
    pageSize: systemSettings.defaultPageSize,
    searchConditions: [],
    ...getDefaultOrderBy(),
  });
  const oriData = useRef<CodeExportInfoListItem[]>([]);

  const tableHeight = 520;
  const listItemType = 'CodeExportInfoListItem';

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'code',
      orderByAscending: true,
    };
  }

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }
  
  function setData(d: Array<any>, callByFetchData: boolean = false) {
    setFocusFirstCell({ dataLength: d.length, focus: callByFetchData });
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeExportInfoListItem, oriData.current, d));
  }

  async function fetchData(api:any,search:Search) {
    setLoading(true);

    const searchModel = CodeExportInfoListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.ExportInfo,
      listItemType,
      searchModel, 1, search.pageSize);
    const data = apiResult && apiResult.entities ? apiResult.entities : [];

    oriData.current = formatData(data);
    setData(formatData(data), true);
    savedDataRef.current = data;
 
    setLoading(false);
    setHasChanges(false);
  }

  // useEffect(() => {
  //  // inlineElement = {};
  //   //setEi(-1);
  //   reload();

  //   return () => {
  //     //tableNavigationCleanup();
  //   };
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   []
  // );

  useEffect(() => {
    if (data.length === 0)
      reload();
    else {
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  async function reload() {
    setOrderBy(getDefaultOrderBy())
    await fetchData(appContext.api, orderBy);
  }

  function onHeaderClick(header: any) {
    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }

      removeData();
      sortingListData(CodeExportInfoListItem, data, setData, orderBy);
    }
  }

  function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }

  
  function addLineItem() {
    const newRow = new EditableCodeExportInfoListItem();
    newRow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newRow
    };
  }

  function applyToLineItem(rowIndex: number, change: Partial<EditableCodeExportInfoListItem>|null) {
    if (!change || !data) {
      return;
    }
    const newData = [...data];
    const checkData = newData[rowIndex];
    if (!change.isNew && (change.code !== checkData.code || change.description !== checkData.description)) {
      _.merge(newData[rowIndex], {..._.omit(change, ['isNew']), hasBeenChanged : true});
      //setHasChanges(true);
      setData(newData);
    }
  }

  function deleteEntity(index: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[index];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.code === element.code)
      if (deleteRow) {
        deleteRow.isDelete = true;
        //setHasChanges(true);
      }
    }
    data.splice(index, 1);
    setData(data);

    return true;
  }

  
  async function save() {
 
    if (!data) {
      return;
    }

    let validData = data.filter((x:any) => x.code);

    let errMsg = '';
    const dataToSave = validData.filter((x: any, i: number) => x.isNew || x.hasBeenChanged === true); // new data is always last so index check works
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload();
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType, SQLType.Delete, _.omit(s, ['isDelete']));
      if (!apiResult || !apiResult.success)
        errMsg = apiResult?.message ?? constants.SAVE_ERROR_MESSAGE;
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave, data, appContext, listItemType, showGlobalOkDialog, JobNames.ExportInfo, 'code',);
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeExportInfoListItem) => a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeExportInfoListItem) => cidData.includes(x.code.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeExportInfoListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success) {
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        }
        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success) {
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        }
        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.code === x.code);
            if (index >= 0) {
              data[index].cid = x.code;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              delete data[index].isNew;
            }
          })
        }
      }
    }

    if (errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }

    // setData(data);
    // savedDataRef.current = _.cloneDeep(data);
    // oriData.current = _.cloneDeep(data);
    
    // setLoading(false);
    // setHasChanges(false);
    reload();

    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  const tableOptions:ApplicableTableSettings = {
    customTableId: 'codes-aes-exportinfo-list',
    selectable: true,
    tableName: 'aesExportInfoList',
    customStorage: tableStorage,
    ...codesAesExportInfoList,
    height: `${tableHeight}px`,
    //    data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel, listSec})),
    data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(),changeLineItem : applyToLineItem })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'code', EditCell: CodeRenderer },
      { accessor: 'description', EditCell: DescriptionRenderer },
    //  { accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
       if (accessor === 'code')
         return { type: TableCellTypes.Text, value: data[rowIndex].code };
       else if (accessor === 'description')
        return { type: TableCellTypes.Text, value: data[rowIndex].description };
       else
         return undefined;
     },
     isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
     },


    onHeaderClick,
    orderBy: [orderBy],
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
    //useTableHelperText: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };
  return (
    <div style={{ marginTop: '40px' }}>
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', width:'100px'}}>
          <div className="ifms-common-bar-element-center">
            <GreenButton size="regular" disabled={loading} onClick={save}><span style={{ textDecoration: 'underline' }}>S</span>ave</GreenButton>
          </div>
          <div style={{margin:'auto'}}></div>
          <div className="ifms-common-bar-element-center">
            <CloseButton onlyIcon name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{ width: '320px', fontSize: '11px', fontWeight: 'bold' }}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''}
            onSearch={generalText1 => {
              setOrderBy({
                general1: generalText1 ? orderBy?.orderBy : null,
                generalText1,
                searchConditions: generalText1
                  ? [{ fieldName: orderBy?.orderBy, condition: 2 }]
                  : [],
              });
              reload();
            }} />
        </div>
        <div style={{ marginLeft: 'auto' }}></div>
        <div style={{ position: 'relative', top: '-4px' }}>
          {/* <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload() }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton> */}
          <RefreshIconButton2 name='list-screen-refresh' onClick={() => { reload() }} disabled={loading} data-tooltip="Refresh"/>
        </div>
      </div>
      <div style={{ width: '864px' }}>
        <EditableTable
          initializeFocusedCell={focusFirstCell}
          tableOptions={tableOptions}
          deleteLine={deleteEntity}
          addLine={addLineItem}
        />
      </div>
      {/* 250721.inhyung.issue#2570. Table 하단에 text 추가. */}
      <div style={{ marginTop: '6px', fontSize: '14px', color: '#000000' }}>
      To add item, press "Insert" Key in any row.<br />
      To delete item, press "Delete" Key on selected row.
    </div>
    </div>
  );
}

export default ExportInfos;
